<template>
  <div class="moduleCard">
    <div class="row mt-4">
      <div class="col-7">
        <div class="row mt-2">
          <div class="col-6">
            <h3 id="available_tags">Available Tags</h3>
          </div>
          <div class="col-6 text-right">
            <button class="btn-std" @click="doLeftSelectAll" name="select_all">Select All</button>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-12">
            <span name="search">Search</span>: <input type="text" class="fullWidth" v-model="leftSearch" @keyup="doLeftSearch" />
          </div>
        </div>

        <div class="mt-2 scroll">
          <select multiple="true" id="selectFrom" class="mSelect">
            <option v-for="i of showItems" v-bind:value="i.LicensePoolTagID" @dblclick="doItemSelect">
              {{i.TagName}}
            </option>
          </select>
        </div>
      </div>
      <div class="col-1 midcolumn text-center">
        <div>
          <button class="btn-transparent" @click="doItemSelect">
            <img src="@/assets/images/scriptingScrollRight.png" alt="Select" />
          </button>
        </div>
        <div class="mt-5">
          <button class="btn-transparent" @click="doItemDeselect">
            <img src="@/assets/images/scriptingScrollLeft.png" alt="Deselect" />
          </button>
        </div>
      </div>
      <div class="col-4">
        <div class="row mt-2">
          <div class="col-6">
            <h3 id="selected_tags">Selected Tags</h3>
          </div>
          <div class="col-6 text-right">
            <button class="btn-std" @click="doRightSelectAll" name="select_all">Select All</button>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <span name="search">Search</span>: <input type="text" class="fullWidth" v-model="rightSearch" @keyup="doRightSearch" />
          </div>

        </div>
        <div class="mt-2 scroll">
          <select multiple="true" id="selectTo" class="mSelect">
            <option v-for="i of showSelectedItems" v-bind:value="i.LicensePoolTagID">
              {{i.TagName}}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12 text-right">
        <button class="btn btn-primary btn-short" @click="doSelect" id="select">Select</button>
      </div>
    </div>
  </div>

</template>


<script>
  export default {
    name: "SelectTags",
    props: ["LicensePoolID"],
    data() {
      return {
        leftSearch: "",
        rightSearch: "",
        itemPool: [],
        selectedItems: [],
        showItems: [],
        showSelectedItems: [],
      }
    },
    methods: {
      doItemDeselect() {
        var sOptions = Array.prototype.slice.call(document.querySelectorAll('#selectTo option:checked'), 0).map(function (v, i, a) {
          return v;
        });
        for (var q = 0; q < sOptions.length; q++) {
          var i = sOptions[q];
          var rid = -1;
          for (var x = 0; x < this.selectedItems.length; x++) {
            if (this.selectedItems[x].LicensePoolTagID === i.value) {
              rid = x;
            }
          }
          if (rid > -1) {
            this.selectedItems.splice(rid, 1);
          }
        }
        this.rightSearch = "";
        this.showSelectedItems = this.selectedItems;
        this.$forceUpdate();

      },
      doItemSelect() {
        var sOptions = Array.prototype.slice.call(document.querySelectorAll('#selectFrom option:checked'), 0).map(function (v, i, a) {
          return v;
        });
        for (var x = 0; x < sOptions.length; x++) {
          var i = sOptions[x];
          if (this.selectedItems.filter(p => p.LicensePoolTagID === i.value).length === 0) {
            var ipi = this.itemPool.filter(p => p.LicensePoolTagID === i.value);
            if (ipi.length > 0) {
              this.selectedItems.push(ipi[0]);
            }
          }
        }
        this.rightSearch = "";
        this.showSelectedItems = this.selectedItems;
        this.$forceUpdate();
      },
      doLeftSearch() {
        if (this.leftSearch.length > 0) {
          this.showItems = [];
          for (var u of this.itemPool) {
            if (u.TagName.toLowerCase().indexOf(this.leftSearch.toLowerCase()) > -1) {
              this.showItems.push(u);
            }
          }
        }
        else {
          this.showItems = this.itemPool;
        }
        this.$forceUpdate();
      },
      doRightSearch() {
        if (this.rightSearch.length > 0) {
          this.showSelectedItems = [];
          for (var u of this.selectedItems) {
            if (u.TagName.toLowerCase().indexOf(this.rightSearch.toLowerCase()) > -1) {
              this.showSelectedItems.push(u);
            }
          }
        }
        else {
          this.showSelectedItems = this.selectedItems;
        }
        this.$forceUpdate();
      },
      doLeftSelectAll() {
        for (var i = 0; i < document.getElementById("selectFrom").options.length; i++) {
          document.getElementById("selectFrom").options[i].selected = true;
        }
      },
      doRightSelectAll() {
        for (var i = 0; i < document.getElementById("selectTo").options.length; i++) {
          document.getElementById("selectTo").options[i].selected = true;
        }
      },
      doSelect() {
        this.$parent.groupsSelected();
      },
      getData() {
        return this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetGroupsWithTag",
            Fields: {
              LicensePoolID: this.LicensePoolID
            }
          }
        ]).then(r => {
          var cr = JSON.parse(r.CommandResult);
          var groups = [];
          for (var group of JSON.parse(cr.returnObjects[0].returnObject)) {
            for (var tag of group.Tags) {
              for (var item of this.selectedItems) {
                if (tag.LicensePoolTagID == item.LicensePoolTagID) {
                  groups.push({ value: tag.LicensePoolGroupID });
                }
              }
            }
          }
          return groups;
        });
        //setTimeout("Window.loadLanguageContent()", 500);
        //alert("hii");
      },
      setData(ip) {
        this.itemPool = [];
        for (var x = 0; x < ip.length; x++) {
          this.itemPool.push(ip[x]);
        }

        this.showItems = this.itemPool;

      }
    }
  }
</script>
